export class InspectionError extends Error {
  constructor(code) {
    super(code);
    this.name = 'InspectionError';
    this.code = code;
  }
}
export function requireCondition(condition, code) {
  if (!condition) throw new InspectionError(code);
}
